<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">玩家建议</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <div>
              <el-select v-model="listQuery.submit_type" filterable placeholder="来源" style="margin-right: 20px">
                <el-option v-for="item in sourceOptions" :key="item.index" :label="item.name" :value="item.id" @click.native="checkModel"> </el-option>
              </el-select>
              <el-select v-model="listQuery.game_id" filterable v-if="!evaluationShow" style="margin-right: 20px" placeholder="游戏" :disabled="!tableCheck">
                <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.game_id_array" filterable collapse-tags multiple v-if="evaluationShow" style="margin-right: 20px" placeholder="游戏" :disabled="!tableCheck">
                <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-input v-model="listQuery.account" placeholder="账号" style="width: 150px; margin-right: 20px" :disabled="!tableCheck"></el-input>
              <el-input v-model="listQuery.game_role_name" placeholder="角色名称" style="width: 150px; margin-right: 20px"></el-input>
              <el-select v-model="listQuery.suggestion_type" filterable placeholder="类型" style="margin-right: 20px" :disabled="!tableCheck">
                <el-option v-for="item in typeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-input v-model="listQuery.suggestion_content" :placeholder="suggestionTxt" style="width: 150px; margin-right: 20px"></el-input>
              <el-select v-model="listQuery.admin_id" filterable placeholder="提交人" style="margin-right: 20px">
                <el-option v-for="item in submitterOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <span v-if="statusShow">回复状态：</span>
              <el-select v-model="listQuery.is_reply" v-if="statusShow" filterable placeholder="回复状态" style="margin-right: 20px">
                <el-option v-for="item in replyOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.is_notice" v-if="statusShow" filterable placeholder="通知状态" style="margin-right: 20px">
                <el-option v-for="item in noticeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <span v-if="evaluationShow">评价：</span>
              <el-select v-model="listQuery.evaluation" v-if="evaluationShow" filterable placeholder="评价" style="margin-right: 20px">
                <el-option v-for="item in evaluationOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-date-picker
                style="margin-top: 10px"
                v-model="listQuery.created_at"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['24:00:00']"
              ></el-date-picker>
            </div>
            <div style="float: right; margin: 20px 30px 10px 0">
              <el-button style="margin-right: 10px; background-color: #00bfbf; color: white" @click="dingNotice" v-if="noticeCheck">通知</el-button>
              <a class="download" :href="downloadFileUrl" title="下载"><el-button type="warning" style="margin: 10px" v-if="modelShow">下载模板</el-button></a>
              <el-upload class="filter-item-upload" :headers="header" :action="serverFileUrl" :on-success="importFaq" style="margin-right: 5px" :show-file-list="false" v-if="modelShow">
                <el-button type="warning" style="margin-top: -2px" v-if="modelShow">批量导入</el-button>
              </el-upload>
              <el-button type="primary" @click="search" icon="el-icon-search" style="margin-left: 10px">搜索</el-button>
              <el-button type="success" @click="addRecord">新增</el-button>
              <el-button type="warning" @click="resetAll">重置</el-button>
              <el-button type="primary" @click="lotImport" v-if="export_button">批量导出</el-button>
              <el-button type="warning" @click="lotevaluat" v-if="evaluationShow">批量评价</el-button>
            </div>
          </div>
        </div>
        <div>
          <el-table
            min-height="200"
            max-height="1000"
            v-if="tableCheck"
            border
            v-loading="listLoading"
            :data="tableData"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'created_at', order: 'descending' }"
            @sort-change="sortChange"
            style="width: 100%"
          >
            <el-table-column type="selection" width="50" class="el-checkbox__inner" v-if="export_button" />
            <el-table-column prop="game_name" label="游戏" width="100" />
            <el-table-column prop="account" label="账号" width="100" />
            <el-table-column prop="game_role_name" label="角色名" width="100" />
            <el-table-column prop="game_server" label="区服" width="100" />
            <el-table-column prop="total_money" label="总充值" sortable @sort-method="sortChange" width="100" />
            <el-table-column v-if="listQuery.submit_type == 2" prop="total_money_week" label="近一周充值" sortable @sort-method="sortChange" width="120" />
            <el-table-column prop="admin_name" label="提交人 " width="80" />
            <el-table-column prop="suggestion_type" label="类型" width="70" />
            <el-table-column prop="submit_type" label="来源" width="70" />
            <el-table-column prop="suggestion_content" label="玩家建议" width="280" :show-overflow-tooltip="true" />
            <el-table-column prop="created_at" label="提交时间" sortable @sort-method="sortChange" width="180" />
            <el-table-column prop="evaluation_text" label="评价" width="100" v-if="evaluationShow" />
            <el-table-column prop="is_reply_text" label="回复状态" width="90" v-if="statusShow" />
            <el-table-column prop="is_notice_text" label="通知状态" width="90" v-if="statusShow" />
            <el-table-column label="操作" v-if="tableCheck" fixed="right">
              <template slot-scope="scope" v-if="tableCheck">
                <el-button size="mini" type="success" @click="viewContent(scope.row)">查看</el-button>
                <el-button size="mini" icon="el-icon-edit" type="primary" @click="edit(scope.row)" v-if="scope.row.update_button">编辑</el-button>
                <el-button size="mini" type="warning" @click="reply(scope.row)" v-if="replyCheck(scope.row.each_reply_button)">回复</el-button>
                <el-button size="mini" type="primary" @click="evaluate(scope.row)" v-if="evaluationShow">评价</el-button>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(scope.row)" v-if="destroy_button">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table border min-height="200" max-height="1000" v-if="!tableCheck" v-loading="listLoading" :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column type="selection" width="50" class="el-checkbox__inner" v-if="export_button" />
            <el-table-column prop="suggestion_content" label="客服建议" />
            <el-table-column prop="is_reply_text" label="回复状态" />
            <el-table-column prop="admin_name" label="提交人" />
            <el-table-column prop="created_at" label="提交时间 " />
            <el-table-column label="操作" v-if="!tableCheck" fixed="right">
              <template slot-scope="scope" v-if="!tableCheck">
                <el-button size="mini" type="success" @click="viewContent(scope.row)">查看</el-button>
                <el-button size="mini" icon="el-icon-edit" type="primary" @click="edit(scope.row)" v-if="scope.row.update_button">编辑</el-button>
                <el-button size="mini" type="warning" @click="reply(scope.row)" v-if="replyCheck(scope.row.each_reply_button)">回复</el-button>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(scope.row)" v-if="destroy_button">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="suggestionList" />
          <el-dialog title="删除" width="40%" center :visible.sync="delShow">
            <p>确认删除？</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="delShow = false">取 消</el-button>
              <el-button type="primary" @click="sureDel">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="evaluateTitle" width="40%" center :visible.sync="lotevaluatShow">
            <el-form style="margin-left: 40px">
              <el-form-item label="评价:" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-select v-model="lotApply" filterable center style="margin-right: 20px">
                    <el-option v-for="item in evaluationOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="lotevaluatShow = false">取 消</el-button>
              <el-button type="primary" @click="sureEvaluat">确 定</el-button>
            </div>
          </el-dialog>

          <div v-if="noticeShow == true">
            <el-dialog title="通知" width="40%" center :visible.sync="noticeShow">
              <el-form style="margin-left: 40px">
                <el-form-item label="通知人" :label-width="formInputWidth">
                  <el-col :span="16">
                    <el-select v-model="noticeReceiver" filterable multiple collapse-tags placeholder="提交人" style="margin-right: 20px">
                      <el-option v-for="item in submitterOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label="通知内容" :label-width="formInputWidth">
                  <el-col :span="16">
                    <el-input type="textarea" v-model="noticeContent" :rows="6"> </el-input>
                  </el-col>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="removeNotice">取 消</el-button>
                <el-button type="primary" @click="sureNotice">确认</el-button>
              </div>
            </el-dialog>
          </div>

          <el-dialog :title="popupTitle" width="60%" center :visible.sync="addRecordShow" :close-on-click-modal="addControl" @close="closeDialog">
            <el-form>
              <el-form-item label="游戏" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.game_id" filterable :disabled="idDisabled">
                    <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <!-- <el-form-item label="账号" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.account" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item> -->
              <el-form-item label="账号" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select
                    v-model="formData.account"
                    :disabled="idDisabled"
                    filterable
                    remote
                    :clearable="true"
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    @change="changeAccount"
                  >
                    <el-option
                      v-for="item in userOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="角色名" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.game_role_name" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="区服" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.game_server" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="类型" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.suggestion_type" filterable :disabled="idDisabled">
                    <el-option v-for="item in typeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="来源" :label-width="formInputWidth">
                <el-col :span="8">
                  <p style="font-weight: bold">{{ source }}</p>
                </el-col>
              </el-form-item>
              <el-form-item label="玩家建议" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="formData.suggestion_content" :rows="4" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="图片" :label-width="formInputWidth" v-if="!idDisabled">
                <el-col :span="16">
                  <el-upload
                    v-model="formData.images"
                    :action="apiUrl"
                    drag
                    multiple
                    list-type="picture-card"
                    :file-list="getStableImageFileList('external-images', fixfilse)"
                    :headers="file_headers"
                    :on-preview="handleFixPreview"
                    :on-success="handleFixSuccess"
                    :on-remove="handleFixRemove"
                    :on-change="(file, fileList) => trackImageUpload('external-images', file, fileList)"
                    :on-error="(error, file, fileList) => handleImageError('external-images', file, fileList)"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogImageFixVisible">
                    <img width="100%" :src="dialogImageFixUrl" alt />
                  </el-dialog>
                </el-col>
              </el-form-item>
              <el-form-item label="图片" :label-width="formInputWidth" v-if="idDisabled">
                <el-col :span="16" class="closeImg">
                  <el-image v-for="item in formData.images" :key="item" :src="item" style="width: 100px; height: 100px; margin-right: 5px" :preview-src-list="formData.images"> </el-image>
                </el-col>
              </el-form-item>
              <el-form-item label="回复内容" :label-width="formInputWidth" v-if="replyContentShow">
                <el-col :span="16">
                  <el-input type="textarea" v-model="formData.replyContent" :rows="4"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <el-table v-if="replyShow" :data="formData.tableData" style="width: 100%; margin-top: 10px">
              <el-table-column prop="reply_admin_name" label="回复人" />
              <el-table-column prop="reply_content" label="回复内容" />
              <el-table-column prop="created_at" label="时间" />
            </el-table>

            <div slot="footer" class="dialog-footer" v-if="buttonShow">
              <el-button @click="addRecordShow = false" v-if="!replyButtonShow">取 消</el-button>
              <el-button type="primary" @click="sureRecord" v-if="!replyButtonShow">确 定</el-button>
              <el-button type="success" @click="sureInsideReply" v-if="replyButtonShow">提 交</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="popupTitle" width="60%" center :visible.sync="insideAddShow" :close-on-click-modal="addControl" @close="insideCloseDialog">
            <el-form>
              <el-form-item label="客服建议" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="inside.suggestion_content" :rows="4" :disabled="insideDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="图片" :label-width="formInputWidth" v-if="!insidePhoto">
                <el-col :span="24">
                  <el-upload
                    v-model="inside.images"
                    :action="apiUrl"
                    drag
                    multiple
                    list-type="picture-card"
                    :file-list="getStableImageFileList('inside-images', insideFilse)"
                    :headers="file_headers"
                    :on-preview="handleFixPreview"
                    :on-success="insideSuccess"
                    :on-remove="insideRemove"
                    :on-change="(file, fileList) => trackImageUpload('inside-images', file, fileList)"
                    :on-error="(error, file, fileList) => handleImageError('inside-images', file, fileList)"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogImageFixVisible">
                    <img width="100%" :src="dialogImageFixUrl" alt />
                  </el-dialog>
                </el-col>
              </el-form-item>

              <el-form-item label="图片" :label-width="formInputWidth" v-if="insidePhoto">
                <el-col :span="16">
                  <el-image v-for="item in inside.images" :key="item" :src="item" style="width: 100px; height: 100px; margin-right: 5px" :preview-src-list="inside.images"> </el-image>
                </el-col>
              </el-form-item>
              <el-form-item label="是否匿名" :label-width="formInputWidth" v-if="sendShow">
                <el-col :span="16">
                  <el-radio-group v-model="inside.inner_anonymous">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-form-item>
              <el-form-item label="选择展示对象" :label-width="formInputWidth" v-if="sendShow">
                <el-col :span="16">
                  <el-select v-model="inside.inner_hide" filterable>
                    <el-option v-for="item in showPersonOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="回复" :label-width="formInputWidth" v-if="replyContentShow">
                <el-col :span="16">
                  <el-input type="textarea" v-model="insideContent" :rows="4"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <el-table v-if="insideReplyTableShow" v-loading="listLoading" :data="inside.tableData" style="width: 100%; margin-top: 10px">
              <el-table-column prop="reply_admin_name" label="回复人" />
              <el-table-column prop="reply_content" label="回复内容" />
              <el-table-column prop="created_at" label="时间" />
            </el-table>
            <div slot="footer" class="dialog-footer" v-if="insideButtonShow">
              <el-button @click="insideAddShow = false" v-if="!replyButtonShow">取 消</el-button>
              <el-button type="primary" @click="sureInsideAdd" v-if="!replyButtonShow">确 定</el-button>
              <el-button type="success" @click="sureInsideReply" v-if="replyButtonShow">提 交</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination/index";
import BASE_API from "@/config";
import { getToken } from "@/utils/localStorage.js";
import '@/assets/css/global.css'
import { getUserRole } from "@/api/login.js";
import {
  getSelectApi,
  addSuggestionApi,
  suggestionListApi,
  getSuggestionApi,
  putSuggestionApi,
  replySuggestionApi,
  deleteSuggestionApi,
  sendeNoticeApi,
  lotEvaluateApi
} from "@/api/serviceRecord.js";
import {
  getAdminUserListApi
} from '@/api/problem.js';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';
export default {
  mixins: [imageUploadMixin],
  components: { Pagination },
  name: "serviceRecord",
  data() {
    return {
      listQuery: {
        submit_type: "",
        game_id: "",
        game_id_array: [],
        evaluation: "",
        account: "",
        game_role_name: "",
        suggestion_type: "",
        suggestion_content: "",
        admin_id: [],
        created_at: "",
        is_reply: "",
        order_field: 0,
        order_type: 0,
        is_notice: "",
        limit: 10,
        page: 1
      },
      tableData: [],
      userOptions: [],
      replyOptions: [],
      gameNameOptions: [],
      typeOptions: [],
      multipleSelection: [],
      submitterOptions: [],
      sourceOptions: [],
      noticeOptions: [],
      formData: {
        game_id: "",
        account: "",
        game_role_name: "",
        game_server: "",
        suggestion_type: "",
        suggestion_content: "",
        submit_type: "",
        replyContent: "",
        images: [],
        tableData: [],
      },
      suggestionTxt: "",
      source: "",
      editID: "",
      replyID: "",
      delID: "",
      // 添加数据的缓存。
      addData: {},   // 非内部
      addCheck: 0,
      // 内部
      insideAddData: {},
      insideAddCheck: 0,

      // 钉钉通知
      noticeShow: false,
      noticeReceiver: [],
      noticeContent: "",

      // 按钮权限
      export_button: false,
      destroy_button: false,
      reply_button: false,
      notice_button: false,
      // 内部数据
      inside: {
        suggestion_content: "",
        submit_type: "",
        inner_anonymous: "",
        inner_hide: "",
        images: [],
        tableData: [],
      },
      showPersonOptions: [
        {
          name: "仅管理员可见",
          id: 1
        },
        {
          name: "所有人可见",
          id: 0
        },
      ],
      insideFilse: [],
      insideDisabled: "",
      insideContent: "",
      insideAddShow: false,
      insidePhoto: "",
      insideReplyShow: false,
      insideButtonShow: "",
      insideReplyTableShow: "",
      operateCheck: "",
      popupTitle: "",
      tableCheck: "",
      addRecordShow: false,
      delShow: false,
      replyShow: false,
      buttonShow: false,
      idDisabled: false,
      replyContentShow: false,
      replyButtonShow: false,
      modelShow: false,
      sendShow: false,
      formInputWidth: "200px",

      // 评价
      evaluationShow: false,
      lotevaluatShow: false,
      lotApply: "",
      evaluationOptions: [],
      evaluateCheck: 0,
      evaluateID: "",
      evaluateTitle: "",

      // 图片参数
      apiUrl: BASE_API + "admin/work_upload_admin",
      fixfilse: [],
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken()
      },
      dialogImageFixVisible: false,
      dialogImageFixUrl: "",

      replyContent: "",
      listLoading: false,
      total: 1,
      // 文件下载
      downloadFileUrl: BASE_API + 'suggestion_excel_download',
      // 批量上传
      serverFileUrl: BASE_API + 'admin/upload_suggestion',
      header: {
        // token: sessionStorage.token
        Authorization: 'Bearer ' + getToken()
      }, // 有的图片服务器要求请求头需要有toke
    }
  },
  computed: {
    noticeCheck() {
      let data = false;
      if (this.notice_button == true && this.listQuery.submit_type != 1) {
        data = true;
      }
      return data;
    },
    statusShow() {
      let data = false;
      if (this.listQuery.submit_type != 1) {
        data = true;
      }
      return data;
    },
    addControl() {
      let item = true;
      if (this.popupTitle == "添加") {
        item = false;
      }
      return item;
    }
  },
  mounted() {
    this.listQuery.submit_type = 1;
    if (JSON.stringify(this.$route.query) != "{}") {
      this.listQuery.submit_type = Number(this.$route.query.submit_type);
    }
    this.modelShow = true;
    this.suggestionTxt = "玩家建议";
    this.getSelect();
    this.suggestionList();
    this.tableCheck = true;
  },
  activated() {
    this.getSelect();
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        getAdminUserListApi({ account: query })
          .then((response) => {
            this.userOptions = response.data.data.map((item) => {
              return {
                ...item,
                value: `${query}_${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}/${item.user_id}`,
                label: `${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}/${item.user_id}`,
              };
            });
            if (this.userOptions.length == 0) {
              this.userOptions = [
                {
                  value: query,
                  label: query,
                }
              ];
            }
          })
          .catch((error) => {
            this.userOptions = [];
          });
      } else {
        this.userOptions = [];
      }
    },
    replyCheck(item) {
      let data = false;
      if (item == true && this.reply_button == true) {
        data = true;
      }
      return data;
    },
    getSelect() {
      let data = {}
      data.submit_type = this.listQuery.submit_type;
      getSelectApi(data)
        .then(response => {
          this.gameNameOptions = response.data.data.game;
          console.log(response.data.data.game,'gameNameOptions')
          this.submitterOptions = response.data.data.admin;
          this.replyOptions = response.data.data.reply;
          this.noticeOptions = response.data.data.notice;
          this.evaluationOptions = response.data.data.evaluation;
          this.typeOptions = []
          for (let item of response.data.data.suggestion) {
            let arr = {};
            arr.name = item;
            arr.id = this.typeOptions.length;
            this.typeOptions.push(arr);
          }
          this.sourceOptions = [];
          let arr = Object.values(response.data.data.submit)
          for (let item of arr) {
            let array = {};
            array.name = item;
            if (item == "普客") {
              array.id = 1;
            }
            else if (item == "VIP") {
              array.id = 2;
            } else if (item == "内部") {
              array.id = 3;
            }
            this.sourceOptions.push(array);
          }
        })
        .catch(error => { })
    },
    async changeAccount(e) {
      const data = this.userOptions.find(item => item.value === e);
      console.log(e,'e',data)

      if (data){
          this.formData.game_role_name = data.role_name;
          this.formData.game_role_id = data.role_id;
          this.formData.server_id = data.server_id;
          this.formData.game_server_name = data.server_name || data.game_server_name;;
          this.formData.game_server = data.server_id


        }else{
          this.formData.game_role_name = "";
          this.formData.game_role_id = "";
          this.formData.game_server_id = "";
          this.formData.game_server_name = "";
          this.formData.game_server = ''

        }
    },
    evaluate(row) {
      this.evaluateTitle = "评价";
      this.evaluateCheck = 1;
      this.evaluateID = row.id;
      this.lotApply = '';
      this.lotevaluatShow = true;
    },
    lotevaluat() {
      this.evaluateTitle = "批量评价";
      this.evaluateCheck = 2;
      this.lotApply = '';
      if (this.multipleSelection.length == 0) {
        this.$message.error("请先选择合服记录");
        return;
      }
      this.lotevaluatShow = true;
    },
    sureEvaluat() {
      let data = {};
      data.id_array = [];
      if (!this.lotApply) {
        this.$message.error("请先选择评价意见");
        return;
      }
      if (this.evaluateCheck == 2) {
        data.id_array = this.multipleSelection.map((item) => {
          return item.id;
        });
      }
      else if (this.evaluateCheck == 1) {
        data.id_array.push(this.evaluateID);
      }
      data.evaluation = this.lotApply;
      lotEvaluateApi(data)
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success("操作成功");
            this.lotevaluatShow = false;
            this.suggestionList();
          }
        })
    },
    suggestionList() {
      this.listLoading = true;
      let arr = JSON.parse(JSON.stringify(this.listQuery));
      if (this.listQuery.submit_type == 1) {
        this.$delete(arr, 'game_id_array');
      } else if (this.listQuery.submit_type == 2) {
        this.$delete(arr, 'game_id');
      }
      suggestionListApi(arr)
        .then(response => {
          this.tableData = response.data.data.data.map(item => {
            return {
              ...item,
              total_money: Number(item.total_money),
            }
          });
          this.total = response.data.data.total;
          this.export_button = response.data.data.export_button;
          this.destroy_button = response.data.data.destroy_button;
          this.reply_button = response.data.data.reply_button;
          this.notice_button = response.data.data.notice_button;
          this.listLoading = false;
        })
        .catch(error => {
          this.listLoading = false;
        })
    },
    sortChange(column) {
      this.listLoading = true;
      if (column.prop === "created_at") {
        this.listQuery.order_field = 0
      } else if (column.prop === "total_money") {
        this.listQuery.order_field = 1
      }
      if (column.order === "ascending") {
        this.listQuery.order_type = 1
      } else if (column.order === "descending") {
        this.listQuery.order_type = 0
      }
      suggestionListApi(this.listQuery)
        .then(response => {
          this.tableData = response.data.data.data.map(item => {
            return {
              ...item,
              total_money: Number(item.total_money),
            }
          });
          this.total = response.data.data.total;
          this.export_button = response.data.data.export_button;
          this.destroy_button = response.data.data.destroy_button;
          this.reply_button = response.data.data.reply_button;
          this.listLoading = false;
        })
        .catch(error => {
          this.listLoading = false;
        });
    },
    dingNotice() {
      if (this.multipleSelection.length == "") {
        this.$message.error("请先选择需要通知的建议")
        return
      }
      this.noticeReceiver = [];
      this.noticeContent = "";
      this.noticeShow = true;
    },
    removeNotice() {
      this.noticeShow = false;
    },
    sureNotice() {
      if (this.noticeReceiver.length == "") {
        this.$message.error("请先选择被通知人");
        return;
      }
      let data = {
        id_array: [],
        admin_ids: [],
        notice_content: "",
        submit_type: ""
      }
      data.admin_ids = this.noticeReceiver;
      for (let item of this.multipleSelection) {
        data.id_array.push(item.id);
      }
      data.notice_content = this.noticeContent;
      data.submit_type = this.listQuery.submit_type;
      sendeNoticeApi(data)
        .then(response => {
          if (response.data.code == 200) {
            this.noticeShow = false;
            this.suggestionList();
            this.$message.success(response.data.message);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => { })
    },
    search() {
      this.listQuery.page = 1;
      this.suggestionList();
    },
    resetAll() {
      this.listQuery.game_id = "";
      this.listQuery.game_id_array = [];
      this.listQuery.evaluation = "";
      this.listQuery.account = "";
      this.listQuery.game_role_name = "";
      this.listQuery.suggestion_type = "";
      this.listQuery.suggestion_content = "";
      this.listQuery.is_notice = "";
      this.listQuery.created_at = "";
      this.listQuery.is_reply = "";
      this.listQuery.is_reply = "";
      this.listQuery.order_field = 0;
      this.listQuery.order_type = 0;
      this.listQuery.limit = 10;
      this.listQuery.page = 1;
      this.game_role_name="";
      this.suggestionList();
    },
    checkModel() {
      if (this.listQuery.submit_type == 1) {
        this.tableCheck = true;  // 非内部
        this.modelShow = true;
        this.evaluationShow = false;
        this.suggestionTxt = "玩家建议";
      } else if (this.listQuery.submit_type == 2) {
        this.tableCheck = true;    // 非内部
        this.modelShow = false;
        this.suggestionTxt = "玩家建议";
        this.evaluationShow = true;
      } else if (this.listQuery.submit_type == 3) {
        this.tableCheck = false;    // 内部
        this.modelShow = false;
        this.evaluationShow = false;
        this.suggestionTxt = "客服建议";
      }
      this.listQuery.page = 1;
      this.suggestionList();
      this.getSelect()
      this.multipleSelection = [];
      this.resetAll();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    lotImport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请先选择合服记录");
        return;
      }
      require.ensure([], () => {
        let {
          export_json_to_excel
        } = require('@/assets/js/Export2Excel');
        let title = "";
        let tHeader = [];
        let filterVal = [];
        if (this.listQuery.submit_type == 1) {  // 普客
          title = "普客合服建议";
          tHeader = ['游戏', '账号', '角色名', '区服', "总充值", "提交人", "类型", "来源", "玩家建议", "提交时间"];
          filterVal = ['game_name', 'account', 'game_role_name', 'game_server', "total_money", "admin_name", "suggestion_type", "submit_type", "suggestion_content", "created_at"];
        } else if (this.listQuery.submit_type == 2) {   // VIP
          title = "VIP合服建议";
          tHeader = ['游戏', '账号', '角色名', '区服', "总充值", "提交人", "类型", "来源", "玩家建议", "提交时间"];
          filterVal = ['game_name', 'account', 'game_role_name', 'game_server', "total_money", "admin_name", "suggestion_type", "submit_type", "suggestion_content", "created_at"];
        } else if (this.listQuery.submit_type == 3) {     // 内部
          title = "内部合服建议";
          tHeader = ['客服建议', '提交人', '提交时间'];
          filterVal = ['suggestion_content', 'admin_name', 'created_at'];
        }
        let list = this.multipleSelection;
        let data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, title);
      })
    },
    addRecord() {
      this.popupTitle = "添加";
      this.operateCheck = 1;
      this.replyButtonShow = false;
      this.replyContentShow = false;
      if (this.tableCheck == false) {   // 内部
        this.resetImageUploadScope('inside-images');
        this.inside.suggestion_content = "";
        this.inside.inner_anonymous = "";
        this.inside.inner_hide = "";
        this.insideFilse = [];
        if (this.insideAddCheck == 1) {
          this.inside = JSON.parse(JSON.stringify(this.insideAddData));
          this.insideFilse = this.inside.images;
        }
        this.sendShow = true;
        this.insideDisabled = false;
        this.insideAddShow = true;
        this.insideButtonShow = true;
        this.insidePhoto = false;
        this.insideReplyTableShow = false;
      }
      else if (this.tableCheck == true) {    // 非内部
        this.resetImageUploadScope('external-images');
        if (this.listQuery.submit_type == 1) {
          this.source = "普客"
        } else if (this.listQuery.submit_type == 2) {
          this.source = "VIP"
        }
        this.formData.game_id = "";
        this.formData.account = "";
        this.formData.game_role_name = "";
        this.formData.game_server = "";
        this.formData.suggestion_type = "";
        this.formData.suggestion_content = "";
        this.formData.images = [];
        this.fixfilse = [];
        if (this.addCheck == 1) {
          this.formData = JSON.parse(JSON.stringify(this.addData));
          this.fixfilse = this.formData.images;
        }
        this.idDisabled = false;
        this.replyShow = false;
        this.buttonShow = true;
        this.addRecordShow = true;
      }
    },
    closeDialog() {
      if (this.popupTitle == "添加" && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.popupTitle == "添加" && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    insideCloseDialog() {
      if (this.popupTitle == "添加" && (this.insideAddCheck == 0 || this.insideAddCheck == 1)) {
        this.insideAddData = JSON.parse(JSON.stringify(this.inside));
        this.insideAddCheck = 1;
      }
      if (this.popupTitle == "添加" && this.insideAddCheck == 2) {
        this.insideAddCheck = 0;
        this.insideAddData = {};
      }
    },
    sureRecord() {
      if (!this.guardImageUploads(['external-images'])) return;
      let data = {}
      data.submit_type = this.listQuery.submit_type;
      data.game_id = this.formData.game_id;
      data.account = this.formData.account;
      data.game_role_name = this.formData.game_role_name;
      data.game_server = this.formData.game_server;
      data.suggestion_type = this.formData.suggestion_type;
      data.suggestion_content = this.formData.suggestion_content;
      data.images = [];
      if(this.formData.account.includes('_')){
        data.account = this.formData.account.split('_')[0]; // 账号
      }
      for (let item of this.formData.images) {
        data.images.push(item.url)
      }
      if (this.operateCheck == 1) {
        addSuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.addCheck = 2;
              this.addRecordShow = false;
              this.listQuery.page = 1;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
      else if (this.operateCheck == 0) {
        data.id = this.editID;
        putSuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.addRecordShow = false;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
    },
    edit(item) {
      this.resetImageUploadScope(this.tableCheck == false ? 'inside-images' : 'external-images');
      this.popupTitle = "编辑";
      this.replyButtonShow = false;
      let data = {}
      data.id = item.id;
      this.editID = item.id;
      this.operateCheck = 0;
      this.replyContentShow = false;
      if (this.tableCheck == false) {   // 内部
        this.insideAddShow = true;
        this.sendShow = true;
        getSuggestionApi(data)
          .then(response => {
            this.inside = response.data.data.suggestion_info;
            this.insideFilse = [];
            for (let item of response.data.data.suggestion_info.images) {
              let arr = {}
              arr.url = item;
              this.insideFilse.push(arr);
            }
            this.inside.images = normalizeImageList(this.insideFilse, 'inside-suggestion');
            this.insideFilse = this.inside.images;
            this.inside.tableData = response.data.data.reply_list;
            this.insideButtonShow = true;
            this.insidePhoto = false;
            this.insideReplyTableShow = true;
            this.insideDisabled = false;
          })
          .catch(error => {
          })
      }
      else if (this.tableCheck == true) {    // 非内部
        if (this.listQuery.submit_type == 1) {
          this.source = "普客"
        } else if (this.listQuery.submit_type == 2) {
          this.source = "VIP"
        }
        this.addRecordShow = true;
        getSuggestionApi(data)
          .then(response => {
            this.formData = response.data.data.suggestion_info
            this.fixfilse = [];
            for (let item of response.data.data.suggestion_info.images) {
              let arr = {}
              arr.url = item;
              this.fixfilse.push(arr);
            }
            this.formData.images = normalizeImageList(this.fixfilse, 'external-suggestion');
            this.fixfilse = this.formData.images;
            this.formData.tableData = response.data.data.reply_list;
            this.idDisabled = false;
            this.replyShow = true;
            this.buttonShow = true;
            this.addRecordShow = true;
          })
          .catch(error => {
          })
      }
    },
    viewContent(item) {
      let data = {}
      data.id = item.id;
      this.replyContentShow = false;
      if (this.tableCheck == false) {   // 内部
        this.sendShow = false;
        this.insideAddShow = true;
        getSuggestionApi(data)
          .then(response => {
            this.inside = response.data.data.suggestion_info;
            this.inside.tableData = response.data.data.reply_list;
          })
          .catch(error => {

          })
        this.insideButtonShow = false;
        this.insidePhoto = true;
        this.insideReplyTableShow = true;
        this.insideDisabled = true;
      }
      else if (this.tableCheck == true) {    // 非内部
        if (this.listQuery.submit_type == 1) {
          this.source = "普客";
        } else if (this.listQuery.submit_type == 2) {
          this.source = "VIP";
        }
        this.addRecordShow = true;
        getSuggestionApi(data)
          .then(response => {
            this.formData = response.data.data.suggestion_info;
            this.formData.tableData = response.data.data.reply_list;
            this.replyShow = item.each_reply_button;
            this.idDisabled = true;
            this.buttonShow = false;
          })
          .catch(error => { })
      }
      this.popupTitle = "查看";
    },
    reply(item) {
      let data = {}
      data.id = item.id;
      this.replyID = item.id;
      this.popupTitle = "回复";
      if (this.tableCheck == false) {   // 内部
        this.insideButtonShow = true;
        this.insidePhoto = true;
        this.insideReplyTableShow = true;
        this.insideDisabled = true;
        this.insideAddShow = true;
        this.replyButtonShow = true;
        this.replyContentShow = true;
        this.sendShow = false;
        this.insideContent = "";
        getSuggestionApi(data)
          .then(response => {
            this.inside = response.data.data.suggestion_info;
            this.inside.tableData = response.data.data.reply_list;
          })
          .catch(error => {
          })
      }
      else if (this.tableCheck == true) {    // 非内部
        if (this.listQuery.submit_type == 1) {
          this.source = "普客"
        } else if (this.listQuery.submit_type == 2) {
          this.source = "VIP"
        }
        getSuggestionApi(data)
          .then(response => {
            response.data.data.suggestion_info.replyContent = "";
            this.formData = response.data.data.suggestion_info;
            this.formData.tableData = response.data.data.reply_list;
          })
        this.popupTitle = "回复";
        this.idDisabled = true;
        this.replyShow = true;
        this.buttonShow = true;
        this.replyButtonShow = true;
        this.replyContentShow = true;
        this.addRecordShow = true;
      }
    },
    sureInsideReply() {
      let data = {}
      data.id = this.replyID;
      if (this.tableCheck == false) {   // 内部
        data.reply_content = this.insideContent;
        if (!this.insideContent) {
          this.$message.error("请填写回复内容")
          return;
        }
        replySuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.insideAddShow = false;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
      else if (this.tableCheck == true) {    // 非内部
        data.reply_content = this.formData.replyContent;
        if (this.listQuery.submit_type == 2) {
          if (!this.formData.replyContent) {
            this.$message.error("请填写回复内容")
            return;
          }
        }
        replySuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.addRecordShow = false;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
      this.insideReplyShow = false;
    },
    del(item) {
      this.delShow = true;
      this.delID = item.id;
    },
    sureDel() {
      let data = {}
      data.id = this.delID;
      deleteSuggestionApi(data)
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            this.delShow = false;
            this.suggestionList();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => { })
      this.delShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 图片相关函数
    handleFixPreview(file) {
      this.dialogImageFixUrl = file.url;
      this.dialogImageFixVisible = true;
    },
    handleFixSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('external-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('external-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.fixfilse = appendImageInSelectionOrder(this.fixfilse, file, { url: response.data.path, name: response.data.name || file.name });
        this.formData.images = this.fixfilse;
        this.trackImageUpload('external-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleFixRemove(file, fileList) {
      this.fixfilse = removeImageByUploadFile(this.fixfilse, file);
      this.formData.images = this.fixfilse;
      this.removeTrackedImage('external-images', file, fileList);
    },
    // 内部数据 图片显示
    insideSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('inside-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('inside-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.insideFilse = appendImageInSelectionOrder(this.insideFilse, file, { url: response.data.path, name: response.data.name || file.name });
        this.inside.images = this.insideFilse;
        this.trackImageUpload('inside-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    insideRemove(file, fileList) {
      this.insideFilse = removeImageByUploadFile(this.insideFilse, file);
      this.inside.images = this.insideFilse;
      this.removeTrackedImage('inside-images', file, fileList);
    },
    sureInsideAdd() {
      if (!this.guardImageUploads(['inside-images'])) return;
      let data = {}
      data.submit_type = this.listQuery.submit_type;
      data.suggestion_content = this.inside.suggestion_content;
      data.inner_anonymous = this.inside.inner_anonymous;
      data.inner_hide = this.inside.inner_hide;
      data.images = [];
      for (let item of this.inside.images) {
        data.images.push(item.url)
      }
      if (this.operateCheck == 1) {
        addSuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.insideAddCheck = 2;
              this.inside.images = [];
              this.insideAddShow = false;
              this.listQuery.page = 1;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
      else if (this.operateCheck == 0) {
        data.id = this.editID;
        putSuggestionApi(data)
          .then(response => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.insideAddShow = false;
              this.suggestionList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => { })
      }
    },
    handleImageError(scope, file, fileList) {
      if (!this.isCurrentImageUpload(scope, file)) return;
      this.trackImageUpload(scope, file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    // 文件批量上传
    importFaq(res, file) {
      if (res.code != 200) {
        this.$message.error(res.message);
      } else {
        this.$message.success(res.message);
        this.suggestionList();
      }
    }
  }
}
</script>

<style >
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
  overflow: hidden;
}
.filter-item-upload {
  display: inline-block;
  margin: 0px 0px 0px 10px;
  transform: translateY(14px);
}
.el-upload--text {
  width: 80px;
  height: 35px;
  border: none;
  margin-top: 10px;
}
</style>
